module.exports = __webpack_public_path__ + "img/fashion_68.c2a52350.jpg";